import { render, staticRenderFns } from "./QuickProspects.vue?vue&type=template&id=e8a48ce0&"
import script from "./QuickProspects.vue?vue&type=script&lang=js&"
export * from "./QuickProspects.vue?vue&type=script&lang=js&"
import style0 from "./QuickProspects.vue?vue&type=style&index=0&id=e8a48ce0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports